import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'next/router'
import Link from 'next/link'
import ReactSVG from 'react-svg'

const ItemContent = ({ text, icon }) => (
	<React.Fragment>
		<ReactSVG src={icon} beforeInjection={svg => {
				svg.setAttribute('style', 'width: 30px; margin-top: 5px; height: 30px;')
			}} wrapper='span' />

			<p>{text}</p>
	</React.Fragment>
)

const renderItem = ({ text, icon, isActive }) => {
	if (!isActive) {
		return (
			<a className='filter-nav-mobile-item'>
				<ItemContent text={text} icon={icon} />
			</a>
		)
	}

	return (
		<a className='filter-nav-mobile-item active' href='javascript:void(0)'>
			<ItemContent text={text} icon={icon} />
		</a>
	)
}

const renderTextSearchItem = ({ isTextSearchActive, textFilterText, textFilterIcon, textSearchDisabled }) => {
	if (isTextSearchActive) return renderItem({ text: textFilterText, icon: textFilterIcon, isActive: true })

	if (textSearchDisabled) {
		return (
			<a className='filter-nav-mobile-item' href='javascript:void(0)'>
				<ItemContent text={textFilterText} icon={textFilterIcon} />
			</a>
		) 
	}

	return (
		<Link
			key='pretraga-po-tekstu'
			href={{ pathname: '/mobileAdFilter', query: { page: 'tekstualna-pretraga' } }}
			as='/mobilna-pretraga/tekstualna-pretraga'
		>
			{renderItem({
				text: textFilterText,
				icon: textFilterIcon,
				isActive: false
			})}
		</Link>
	)
}

const NavigationMobile = ({ router, textSearchDisabled }) => {
	const isTextSearchActive = router.asPath === '/mobilna-pretraga/tekstualna-pretraga'

	const textFilterText = 'Pretraga po tekstu'
	const textFilterIcon = '/icons/pretraga-po-tekstu.svg'
	const categoryFilterText = 'Pretraga po filterima'
	const categoryFilterIcon = '/icons/pretraga-po-filterima.svg'

  return (
		<div className='filter-nav-mobile'>
			{renderTextSearchItem({ isTextSearchActive, textFilterText, textFilterIcon, textSearchDisabled })}

			{!isTextSearchActive ?
				renderItem({
					text: categoryFilterText,
					icon: categoryFilterIcon,
					isActive: true
				}) : (
					<Link
						key='pretraga-po-filterima'
						href={{ pathname: '/mobileAdFilter', query: { page: 'category-filter' } }}
						as='/mobilna-pretraga'
					>
						{renderItem({
							text: categoryFilterText,
							icon: categoryFilterIcon,
							isActive: false
						})}
					</Link>
				)
			}
		</div>
	)
}

NavigationMobile.propTypes = {
  router: PropTypes.shape({
    asPath: PropTypes.string.isRequired
  }),
	textSearchDisabled: PropTypes.bool
}

export default withRouter(NavigationMobile)
